module.exports = __webpack_public_path__ + "media/rareItem.8f93a915.wav";